import { sessionClient } from "@/di/api";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import paths from "./paths";

// a busca é a página por trás do perfil do psi (painel); o mesmo componente nas duas rotas
// faz o Vue reaproveitar a tela: a lista não recarrega ao abrir e fechar o perfil
const SearchPsi = () => import("../views/SearchPsi/SearchPsi.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: paths.searchPsi,
    name: "SearchPsi",
    alias: "/",
    component: SearchPsi,
  },
  {
    path: paths.home,
    name: "Home",
    component: () => import("../views/Home/Home.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: paths.login,
    name: "Login",
    component: () => import("../views/Login/Login.vue"),
  },
  {
    path: paths.passwordReset,
    name: "PasswordReset",
    component: () => import("../views/PasswordReset/PasswordReset.vue"),
  },
  {
    path: paths.register.base,
    name: "Register",
    component: () => import("../views/Register/Register.vue"),
    children: [
      {
        path: paths.register.children.info,
        name: "RegisterInfo",
        component: () => import("../views/Register/RegisterInfo.vue"),
      },
      {
        path: paths.register.children.nickname,
        name: "RegisterNickname",
        component: () => import("../views/Register/RegisterNickname.vue"),
      },
    ],
  },
  {
    path: `${paths.settings}/:id`,
    name: "Settings",
    component: () => import("../views/Settings/Settings.vue"),
    props: true,
  },
  {
    path: paths.blog,
    name: "Blog",
    component: () => import("../views/Blog/Blog.vue"),
  },
  // endereço antigo (links salvos e compartilhados), mantendo o filtro ?psiapp_user_id
  { path: "/blog", redirect: (to) => ({ path: paths.blog, query: to.query }) },
  {
    path: `${paths.more}/:path?`,
    name: "More",
    component: () => import("../views/More/More.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: `${paths.chats}/:id?`,
    name: "Chats",
    component: () => import("../views/Chats/Chats.vue"),
    props: true,
  },
  // o perfil virou painel lateral: /psi/:slug é a busca com o perfil aberto (o link compartilhável
  // fica na barra enquanto o painel está aberto)
  {
    path: `${paths.psiDetail}/:id`,
    name: "PsiDetail",
    component: SearchPsi,
  },
  { path: paths.psiDetail, redirect: paths.searchPsi },
  {
    // a escolha de data virou painel (empilha no perfil ou no detalhe da sessão); o endereço antigo vai para Sessões
    path: paths.scheduleDate,
    name: "AppointmentScheduleDate",
    redirect: paths.appointments.list,
  },
  {
    path: `${paths.custom_schedule}/:uuid`,
    name: "CustomSchedule",
    component: () => import("../views/CustomSchedule/CustomSchedule.vue"),
    props: true,
  },
  {
    // o checkout virou painel (empilha na data da sessão ou no horário avulso); o endereço antigo vai para a busca
    path: paths.checkout,
    name: "Checkout",
    redirect: paths.searchPsi,
  },
  {
    path: paths.appointments.list,
    name: "Appointments",
    component: () => import("../views/Appointments/Appointments.vue"),
    meta: { requiresAuth: true },
  },
  // o detalhe virou painel lateral (como no pro): o endereço antigo abre Sessões com o painel aberto
  {
    path: `${paths.appointments.detail}/:id`,
    name: "AppointmentDetail",
    redirect: (to) => ({ path: paths.appointments.list, query: { sessao: String(to.params.id) } }),
  },
  {
    path: `${paths.callScreen}/:callId`,
    name: "LiveCall",
    component: () => import("../views/LiveCallScreen/LiveCallScreen.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: paths.not_found,
    name: "NotFound",
    component: () => import("../views/NotFound/NotFound.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: {
      name: "NotFound",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const session = sessionClient.getSession();

  // exclusivo do main: a raiz é pública (busca) para visitantes e a home para quem está logado
  if (to.path === "/") {
    next(session ? paths.home : paths.searchPsi);
    return;
  }

  if (to.meta.requiresAuth && !session) {
    next(paths.login);
    return;
  }

  next();
});

export default router;
